import React, { useContext } from 'react';
import Node from './Node';
import { useParams } from 'react-router-dom';
import { RootContext } from '../../Context/RootContext';
const Content = () => {
    // Get startNodeUid from URL using useParams of fallback to plugin settings.
    const { id = useContext(RootContext).pluginContext.startNodeUid } = useParams();
    return React.createElement(Node, { startNodeId: parseInt(id) });
};
export default Content;
